import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
export const JobListingsEntry = ({ id, title, headline, text, unfoldedState = false, windowWidth, }) => {
    const [isUnfolded, setIsUnfolded] = useState(false);
    const [maxHeight, setMaxHeight] = useState(78);
    const jobListingEntryRef = useRef(null);
    const jobListingEntryHeaderRef = useRef(null);
    useEffect(() => {
        setIsUnfolded(unfoldedState);
    }, [unfoldedState]);
    useEffect(() => {
        const newMaxHeight = isUnfolded
            ? jobListingEntryRef.current?.scrollHeight
            : jobListingEntryHeaderRef.current?.scrollHeight;
        if (newMaxHeight) {
            setMaxHeight(newMaxHeight);
        }
    }, [windowWidth, isUnfolded]);
    return (React.createElement("div", { className: classNames('job-listings-entry', { 'is-collapsed': !isUnfolded }), ref: jobListingEntryRef, style: {
            maxHeight: maxHeight,
        } },
        React.createElement("div", { className: 'entry-header', ref: jobListingEntryHeaderRef, onClick: () => setIsUnfolded(!isUnfolded) },
            React.createElement("h3", null, title)),
        React.createElement("div", { className: 'entry-body' },
            React.createElement("p", { className: 'text-headline' },
                React.createElement("strong", null, headline)),
            React.createElement("div", { className: 'text', dangerouslySetInnerHTML: { __html: text } }),
            React.createElement("div", { className: 'btns-container' },
                React.createElement("a", { className: 'btn is-primary', href: `/vacancy-apply/${id}` }, "Apply now"),
                React.createElement("a", { href: `${document.querySelector('meta[property="og:url"]')?.getAttribute('content')}/vacancy/${id}` }, "read more")))));
};
export default JobListingsEntry;
